// noinspection DuplicatedCode

import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Card } from "@material-tailwind/react";
import { useMutation } from "@tanstack/react-query";
import DatePicker from "react-datepicker";
import { BiArrowBack, BiPrinter } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import debounce from "lodash/debounce";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { Colors } from "../../../assets/Colors";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import { ChangeToString } from "../../../components/form/ObjectChanger";
import { isRequired, useForm } from "../../../components/isRequired";
import Skeltons from "../../../components/loading/Skeltons";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { getObjectIdsByPRListID } from "../../../components/tools/PCGetter";
import {
  fetchGet,
  fetchPost,
  fetchPostMultipartSeaweed,
  fetchPut,
} from "../../../fetchers";
import { Currency, Top } from "../purchase-requisition/configuration";

const InsertPriceComparisonPage = ({}) => {
  const MAX_MSR_OPTIONS_RENDER = 200;
  let initialState = {
    SupplierCount: 0,
    BisnisUnitID: "U0002",
  };

  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
  ];

  const { values, touched, customHandler, changeHandler, errors, blastChange } =
    useForm(initialState, validations);

  const [buttonTouched, setButtonTouched] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [prData, setPRData] = useState([]);
  const [allPrData, setAllPrData] = useState([]);
  const [msrSearchInput, setMsrSearchInput] = useState("");
  const [barang, setBarang] = useState([]);
  const [pRListComparison, setPRListComparison] = useState([]);
  const [showDetail, setshowDetail] = useState(true);
  const [isJasa, setisJasa] = useState(false);
  const [Termin1, setTermin1] = useState("");
  const [Termin2, setTermin2] = useState("");
  const [Termin3, setTermin3] = useState("");
  const [prDetailData, setprDetailData] = useState([]);
  // Nominal uang muka MSR (dari backend). >0 → Termin 1 dihitung otomatis dari
  // persentase DP terhadap Grand Total supplier yang sedang aktif.
  const [downpaymentAmount, setDownpaymentAmount] = useState(0);

  const barangDetail = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [supplierSelected, setSupplierSelected] = useState(1);

  const ModalOpener = (detail) => {
    setShowModal(true);
  };

  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/PriceComparison", formData)
  );

  const PurchaseRequisition = useMutation((formData) =>
    fetchPost("Procurement/PurchaseRequisition/minv2", formData)
  );

  const PurchaseRequisitionDetail = useMutation((formData) =>
    fetchGet("Procurement/PurchaseRequisitionStockOnly/" + formData)
  );

  const PurchaseRequisitionUpdate = useMutation((formData) =>
    fetchPut("Procurement/PriceComparison", formData)
  );

  const franco = useMutation((formData) => fetchGet("Master/Franco/min"));

  const PriceComparison = useMutation((formData) =>
    fetchGet("Procurement/PriceComparison/" + formData)
  );

  const param = useLocation();
  const params = useParams();
  const mutationFile = useMutation((formData) =>
    fetchPostMultipartSeaweed(formData)
  );

  const supplier = useMutation((formData) => fetchGet("Master/Supplier/min"));

  const navigate = useNavigate();

  const filterMsrOptions = useCallback((source, keyword) => {
    if (!Array.isArray(source)) return [];
    const q = (keyword || "").trim().toLowerCase();

    if (!q) {
      return source.slice(0, MAX_MSR_OPTIONS_RENDER);
    }

    return source
      .filter((item) => {
        const msr = (item.PurchaseRequisitionID || "").toLowerCase();
        const remarks = (item.Remarks || "").toLowerCase();
        const requester = (item.Requester || "").toLowerCase();
        return msr.includes(q) || remarks.includes(q) || requester.includes(q);
      })
      .slice(0, MAX_MSR_OPTIONS_RENDER);
  }, []);

  const debouncedMsrFilter = useMemo(
    () =>
      debounce((keyword, source) => {
        setPRData(filterMsrOptions(source, keyword));
      }, 250),
    [filterMsrOptions]
  );

  useEffect(() => {
    barangDetail.mutate();
    if (params.id) {
      customHandler(params.id, "BisnisUnitID");
      PurchaseRequisition.mutate({ BisnisUnitID: params.id });
    }

    franco.mutate();
    supplier.mutate();
    if (params.transid) {
      PriceComparison.mutate(params.transid.replaceAll("-", "/"));
    }
  }, []);

  useEffect(() => {
    return () => {
      debouncedMsrFilter.cancel();
    };
  }, [debouncedMsrFilter]);

  useEffect(() => {
    if (allPrData && params.transid) {
      const index = allPrData.findIndex((x) => {
        return x.PurchaseRequisitionID == params.msr.replaceAll("-", "/");
      });
      customHandler(index, "PurchaseRequisitionID");
    }
    if (params.msr) {
      PurchaseRequisitionDetail.mutate(params.msr);
    }
  }, [allPrData]);

  useEffect(() => {
    if (mutationAdd.isSuccess) {
      navigate("/procurment/transaksi/price-comparison/" + params.id);
    }
  }, [mutationAdd.status]);

  useEffect(() => {
    if (PurchaseRequisitionUpdate.isSuccess) {
      navigate("/procurment/transaksi/price-comparison/" + params.id);
    }
  }, [PurchaseRequisitionUpdate.status]);

  useEffect(() => {
    if (PurchaseRequisitionDetail.data) {
      setisJasa(
        PurchaseRequisitionDetail.data.data.Tipe == "Jasa" ? true : false
      );
      setTermin1(PurchaseRequisitionDetail.data.data.Termin1);
      setTermin2(PurchaseRequisitionDetail.data.data.Termin2);
      setTermin3(PurchaseRequisitionDetail.data.data.Termin3);
      setDownpaymentAmount(
        parseFloat(PurchaseRequisitionDetail.data.data.DownpaymentAmount) || 0
      );
      // `|| []` — PRList bisa null (lihat catatan di SupplierCount); state ini
      // dipakai sebagai `data` DynamicTableSimple yang mengharapkan array.
      setBarang(PurchaseRequisitionDetail.data.data.PRList || []);
    }
  }, [PurchaseRequisitionDetail.data]);

  // Fungsi untuk menghitung ulang total supplier dengan perhitungan pajak yang benar
  const calculateSupplierTotal = (supplierData) => {
    if (!supplierData || !supplierData.PRListComparison) return supplierData;

    let subtotalBeforeDiscount = 0; // Total sebelum diskon apa pun
    let totalItemDiscount = 0; // Total diskon per item

    // Hitung subtotal dan diskon per item
    const updatedPRList = supplierData.PRListComparison.map((item) => {
      const harga = parseFloat(item["Harga"] || 0);
      const qty = parseFloat(item["Qty"] || 0);
      const totalHarga = harga * qty;

      // Hitung diskon per item
      let itemDiscount = 0;
      const itemDiscountPercent = parseFloat(item["DiscountPercent"] || 0);
      const itemDiscountRupiah = parseFloat(item["DiscountRupiah"] || 0);

      if (itemDiscountPercent > 0) {
        itemDiscount = (totalHarga * itemDiscountPercent) / 100;
      } else if (itemDiscountRupiah > 0) {
        itemDiscount = itemDiscountRupiah;
      }

      const totalAfterItemDiscount = totalHarga - itemDiscount;

      subtotalBeforeDiscount += totalHarga;
      totalItemDiscount += itemDiscount;

      return {
        ...item,
        TotalHarga: totalAfterItemDiscount, // Total setelah diskon per item
        ItemDiscount: itemDiscount,
        TotalBeforeDiscount: totalHarga, // Nilai sebelum diskon per item
      };
    });

    // Subtotal setelah diskon per item
    const subtotalAfterItemDiscount = subtotalBeforeDiscount - totalItemDiscount;

    // Hitung diskon global (supplier level)
    const globalDiscountPercent = parseFloat(
      supplierData["DiscountPercent"] || 0
    );
    const globalDiscountRupiah = parseFloat(
      supplierData["DiscountRupiah"] || 0
    );
    let globalDiscount = 0;

    if (globalDiscountPercent > 0) {
      globalDiscount =
        (subtotalAfterItemDiscount * globalDiscountPercent) / 100;
    } else if (globalDiscountRupiah > 0) {
      globalDiscount = globalDiscountRupiah;
    }

    // Total setelah semua diskon (per item + global)
    const totalAfterAllDiscounts = subtotalAfterItemDiscount - globalDiscount;

    // AMBIL NILAI PPN, PPH, PBBKB DARI INPUT USER
    const ppnPercent = parseFloat(supplierData["PPN"] || 0);
    const pphPercent = parseFloat(supplierData["PPH"] || 0);
    const pbbkbPercent = parseFloat(supplierData["PBBKB"] || 0);

    // Hitung pajak berdasarkan TOTAL SETELAH SEMUA DISKON
    const ppnTotal = (totalAfterAllDiscounts * ppnPercent) / 100;
    const pphTotal = (totalAfterAllDiscounts * pphPercent) / 100;
    const pbbkbTotal = (totalAfterAllDiscounts * pbbkbPercent) / 100;

    // Biaya Lain-lain (nominal) di LUAR biaya utama: ditambahkan SETELAH pajak, jadi
    // PPN/PPH/PBBKB tetap dihitung dari total barang/jasa dan tidak ikut membesar.
    // Dijurnal ke Beban divisi (backend: GA pertama / PO Jasa termin 1).
    const biayaLain = Math.max(0, parseFloat(supplierData["BiayaLain"] || 0) || 0);

    // Grand Total: Total setelah diskon + PPN + PBBKB - PPH + Biaya Lain-lain
    const grandTotal =
      totalAfterAllDiscounts + ppnTotal + pbbkbTotal - pphTotal + biayaLain;

    return {
      ...supplierData,
      PRListComparison: updatedPRList,
      // Ringkasan perhitungan
      SubtotalBeforeDiscount: subtotalBeforeDiscount, // Total sebelum diskon apa pun
      TotalItemDiscount: totalItemDiscount, // Total diskon per item
      SubtotalAfterItemDiscount: subtotalAfterItemDiscount, // Total setelah diskon per item
      GlobalDiscount: globalDiscount, // Diskon global
      TotalAfterAllDiscounts: totalAfterAllDiscounts, // Total setelah semua diskon
      // Nilai pajak dan persentase
      PPNPercent: ppnPercent,
      PPHPercent: pphPercent,
      PBBKBPercent: pbbkbPercent,
      PPNTotal: ppnTotal,
      PPHTotal: pphTotal,
      PBBKBTotal: pbbkbTotal,
      BiayaLainTotal: biayaLain,
      GTOTAL: grandTotal,
      // Kompatibilitas dengan kode lama
      Total: subtotalAfterItemDiscount, // Untuk backward compatibility
      Discound: globalDiscount, // Untuk backward compatibility
      Total2: totalAfterAllDiscounts, // Untuk backward compatibility
    };
  };

  useEffect(() => {
    if (PriceComparison.data) {
      const tempArray = PriceComparison.data.data;
      if (tempArray && tempArray[0] && tempArray[0]["PurchaseRequisitionID"]) {
        customHandler(tempArray.length, "SupplierCount");

        // Inisialisasi data supplier dengan benar
        const updatedArray = tempArray.map((item) => {
          if (item["PRListComparison"]) {
            // Gabungkan data dari PRList dengan data yang ada di PRListComparison
            const updatedPRList = item["PRListComparison"].map((detail) => {
              // Gabungkan data dari PRList asli (untuk mendapatkan Qty asli)
              const matchingObjectIds = getObjectIdsByPRListID(
                PurchaseRequisitionDetail.data?.data?.PRList || [],
                detail["PRListID"]
              );

              const prListData = matchingObjectIds[0] || {};

              // Gabungkan data: Qty dari PRList asli, lainnya dari PRListComparison
              const mergedDetail = {
                ...prListData, // Data dari PRList asli (termasuk Qty)
                ...detail, // Data dari PRListComparison (termasuk Harga, Diskon, dll)
              };

              // Pastikan Qty dari PRList asli digunakan
              if (prListData.Qty) {
                mergedDetail["Qty"] = prListData.Qty;
              }

              return mergedDetail;
            });

            // Hitung ulang summary dengan fungsi calculateSupplierTotal
            return calculateSupplierTotal({
              ...item,
              PRListComparison: updatedPRList,
            });
          }
          return item;
        });

        setPRListComparison(updatedArray);
        setSupplierSelected(1); // Reset ke supplier pertama
      }
    }
  }, [PriceComparison.data, PurchaseRequisitionDetail.data]);

  useEffect(() => {
    if (PurchaseRequisition.data && PurchaseRequisition.data.data) {
      const tempArray = PurchaseRequisition.data.data.map((datas, i) => ({
        ...datas,
        value: i,
        label: `${datas.PurchaseRequisitionID} - ${datas.Remarks}`,
      }));
      setAllPrData(tempArray);
      setPRData(filterMsrOptions(tempArray, ""));
    }
  }, [PurchaseRequisition.data, filterMsrOptions]);

  const selectedPROption = useMemo(() => {
    return (
      allPrData.find(({ value }) => value === values["PurchaseRequisitionID"]) ||
      null
    );
  }, [allPrData, values["PurchaseRequisitionID"]]);

  const header = [
    { name: "Nama Barang/Jasa", key: "BarangID", modifiers: "Barang" },
    { name: "JUMLAH PENGAJUAN", key: "Qty", modifiers: "number" },
    { name: "TANGGAL DIBUTUHKAN", key: "SDTDate", modifiers: "dateOnlyNew" },
    { name: "Spesifikasi", key: "Specification", modifiers: "Text" },
  ];

  const PRHandlerWithMSR = (label, value, names, secondValue) => {
    const blastChanges = {
      SupplierCount: 0,
      PurchaseRequisitionID: value,
      PurchaseRequisitionIDR: secondValue,
    };
    blastChange(blastChanges);
    PurchaseRequisitionDetail.mutate(secondValue.replaceAll("/", "-"));

    const selectedPR = allPrData.find((pr) => pr.value === value);
    if (selectedPR) {
      setisJasa(selectedPR.Tipe == "Jasa");
      setTermin1(selectedPR.Termin1 || "");
      setTermin2(selectedPR.Termin2 || "");
      setTermin3(selectedPR.Termin3 || "");
    }
  };

  const handleMsrInputChange = useCallback(
    (inputValue, meta) => {
      if (meta?.action !== "input-change") {
        return inputValue;
      }
      setMsrSearchInput(inputValue || "");
      debouncedMsrFilter(inputValue || "", allPrData);
      return inputValue;
    },
    [allPrData, debouncedMsrFilter]
  );

  const SupplierCount = (e) => {
    const count = parseInt(e.target.value) || 0;
    changeHandler(e);

    // Backend mengirim "PRList": null (bukan array kosong) bila MSR tak punya
    // satu pun item yang bisa dibandingkan — query GetPurchaseRequisitionStockOnly
    // menyaring item ber-IsStock=true (sudah tersedia di gudang) dan item yang
    // Dibatalkan. Dulu `.map` dipanggil langsung di sini, jadi MSR seperti itu
    // melempar TypeError yang membekukan seluruh form tanpa pesan apa pun.
    const prList = PurchaseRequisitionDetail.data?.data?.PRList || [];
    const detailArray = prList.map((detail) => ({
      ...detail,
      Harga: 0,
      DiscountPercent: 0,
      DiscountRupiah: 0,
      Merk: "",
      PilihanBeli: false,
      TotalHarga: 0,
      ItemDiscount: 0,
      TotalAfterItemDiscount: 0,
    }));

    if (count > 0 && PurchaseRequisitionDetail.data && prList.length === 0) {
      toast.warn(
        "MSR ini tidak punya item yang bisa dibandingkan — semua itemnya sudah ditandai tersedia di gudang atau dibatalkan.",
        { position: "bottom-right", autoClose: 6000 }
      );
    }

    if (count > 0) {
      const TempArray = Array.from({ length: count }, (_, i) => ({
        TanggalKirim: new Date(),
        PPN: 0,
        PPH: 0,
        PBBKB: 0,
        BiayaLain: 0,
        KeteranganBiayaLain: "",
        NamaFile: null,
        DiscountPercent: 0,
        DiscountRupiah: 0,
        NamaSupplier: "",
        Quotation: "",
        FrancoID: "",
        TOP: "",
        Currency: "",
        TOC: "",
        // Field perhitungan baru
        SubtotalBeforeDiscount: 0,
        TotalItemDiscount: 0,
        SubtotalAfterItemDiscount: 0,
        GlobalDiscount: 0,
        TotalAfterAllDiscounts: 0,
        PPNPercent: 0,
        PPHPercent: 0,
        PBBKBPercent: 0,
        PPNTotal: 0,
        PPHTotal: 0,
        PBBKBTotal: 0,
        BiayaLainTotal: 0,
        GTOTAL: 0,
        // Untuk backward compatibility
        Total: 0,
        Discound: 0,
        Total2: 0,
        PRListComparison: JSON.parse(JSON.stringify(detailArray)),
      }));

      setPRListComparison(TempArray);
      setSupplierSelected(1); // Reset ke supplier pertama
    } else {
      setPRListComparison([]);
    }
  };

  const PurchaseRequisitionDetailEditor = (supplierIndex, itemIndex, e) => {
    const tempArray = [...pRListComparison];
    const selectedSupplier = tempArray[supplierIndex];

    if (!selectedSupplier || !selectedSupplier.PRListComparison) return;

    const fieldName = e.target.name;
    let fieldValue = e.target.value;

    // Jika field adalah number, parse ke float
    if (["Harga", "DiscountPercent", "DiscountRupiah"].includes(fieldName)) {
      fieldValue = parseFloat(fieldValue) || 0;
    }

    if (fieldName === "PilihanBeli") {
      fieldValue = e.target.checked;
    }

    // Update nilai field
    selectedSupplier.PRListComparison[itemIndex][fieldName] = fieldValue;

    // Jika mengubah diskon persen, reset diskon rupiah
    if (fieldName === "DiscountPercent" && fieldValue > 0) {
      selectedSupplier.PRListComparison[itemIndex]["DiscountRupiah"] = 0;
    }

    // Jika mengubah diskon rupiah, reset diskon persen
    if (fieldName === "DiscountRupiah" && fieldValue > 0) {
      selectedSupplier.PRListComparison[itemIndex]["DiscountPercent"] = 0;
    }

    // Hitung ulang dengan fungsi calculateSupplierTotal
    tempArray[supplierIndex] = calculateSupplierTotal(selectedSupplier);

    setPRListComparison(tempArray);
  };

  const SupplierBuilder = () => {
    if (!values.SupplierCount || values.SupplierCount <= 0) {
      return null;
    }

    return Array.from({ length: values.SupplierCount }, (_, i) => i + 1).map(
      (supplierNumber) => (
        <li key={supplierNumber} className="mr-2" role="presentation">
          <button
            onClick={() => {
              console.log("Mengklik tab supplier:", supplierNumber);
              setSupplierSelected(supplierNumber);
            }}
            className={`
            inline-block p-4 rounded-t-lg border-b-2 font-medium text-sm
            ${
              supplierSelected === supplierNumber
                ? "text-blue-600 border-blue-600 bg-white"
                : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300"
            }
          `}
            type="button"
            role="tab"
            aria-selected={supplierSelected === supplierNumber}
          >
            Supplier - {supplierNumber}
          </button>
        </li>
      )
    );
  };

  const onChangeTermin = (e) => {
    const { name, value } = e.target;
    if (name === "Termin1") {
      setTermin1(value);
    } else if (name === "Termin2") {
      setTermin2(value);
    } else if (name === "Termin3") {
      setTermin3(value);
    }
  };

  const prEditor = (name, supplierIndex, value) => {
    const tempArray = [...pRListComparison];

    if (supplierIndex >= 0 && supplierIndex < tempArray.length) {
      tempArray[supplierIndex][name] = value;

      // Hitung ulang dengan fungsi calculateSupplierTotal
      tempArray[supplierIndex] = calculateSupplierTotal(
        tempArray[supplierIndex]
      );

      setPRListComparison(tempArray);
    }
  };

  // Grand Total supplier yang sedang aktif (tab dibuka) — basis auto-hitung Termin 1.
  const activeGrandTotal =
    parseFloat(pRListComparison[supplierSelected - 1]?.GTOTAL || 0) || 0;

  // Uang muka otomatis (metode BARU 2026-08-20). Mereplika persis aturan backend
  // createDownpaymentFromCashPC: kandidat = supplier ber-Term of Payment Cash ("0")
  // yang punya MINIMAL SATU item terpilih (PilihanBeli); nominalnya = Grand Total
  // TERENDAH di antara kandidat itu. 0 = tak ada uang muka otomatis.
  // Dihitung dari seluruh pRListComparison (bukan supplier tab aktif saja) karena
  // pembentukannya memang lintas-supplier.
  const cashDownpaymentAmount = (() => {
    const kandidat = (pRListComparison || [])
      .filter(
        (s) =>
          s &&
          String(s["TOP"]) === "0" &&
          (s["PRListComparison"] || []).some(
            (it) =>
              it && (it["PilihanBeli"] === true || it["PilihanBeli"] === "true")
          )
      )
      .map((s) => parseFloat(s["GTOTAL"] || 0) || 0)
      .filter((v) => v > 0);
    return kandidat.length ? Math.min(...kandidat) : 0;
  })();

  // Perkiraan uang muka SEBELUM approver mencentang PilihanBeli. cashDownpaymentAmount
  // di atas memakai aturan backend apa adanya (butuh item terpilih), sehingga saat form
  // baru diisi nilainya masih 0 — padahal justru di sinilah user ingin tahu berapa yang
  // akan terbentuk. Perkiraan ini mengabaikan PilihanBeli; angka finalnya tetap milik
  // backend saat approval final.
  const cashDownpaymentEstimasi = (() => {
    const kandidat = (pRListComparison || [])
      .filter((s) => s && String(s["TOP"]) === "0")
      .map((s) => parseFloat(s["GTOTAL"] || 0) || 0)
      .filter((v) => v > 0);
    return kandidat.length ? Math.min(...kandidat) : 0;
  })();

  // Mode pembayaran dokumen. Sumber kebenarannya TETAP kolom per-supplier
  // PRComparison."top" — tak ada state/kolom baru — sehingga backend Fase C
  // (createDownpaymentFromCashPC) tidak perlu diubah sama sekali.
  const isCashMode = (pRListComparison || []).some(
    (s) => s && String(s["TOP"]) === "0"
  );

  // Supplier baru lahir dengan TOP kosong, sementara backend memvalidasinya `required`.
  // Selama belum ada satu pun TOP terisi, select DIBIARKAN KOSONG — kalau ia langsung
  // menampilkan "Term of Payment", user mengira pilihannya sudah beres lalu tertahan
  // pesan validasi saat menyimpan.
  const adaTopTerisi = (pRListComparison || []).some(
    (s) => s && String(s["TOP"] || "") !== ""
  );

  // Term of Payment default saat user kembali dari Cash. Bukan pilihan final —
  // jangka waktu per supplier tetap bisa diubah di dropdown Term of Payment
  // masing-masing tab supplier.
  const TOP_DEFAULT_HARI = "30";

  const ModePembayaran = [
    { label: "Term of Payment", value: "top" },
    { label: "Cash", value: "cash" },
  ];

  // Menukar mode menyentuh SELURUH supplier: "Cash" adalah sifat dokumen, bukan
  // sifat satu penawaran. Saat kembali ke Term of Payment hanya supplier yang tadinya
  // Cash yang diubah, supaya jangka waktu yang sudah diisi di supplier lain tak hilang.
  const setModePembayaran = (mode) => {
    setPRListComparison(
      (pRListComparison || []).map((s) => {
        if (!s) return s;
        if (mode === "cash") return { ...s, TOP: "0" };
        if (String(s["TOP"]) === "0") return { ...s, TOP: TOP_DEFAULT_HARI };
        return s;
      })
    );
  };

  // Cash → Termin 1 = 100%. Uang mukanya memang SELURUH Grand Total (Keputusan 2),
  // jadi tak ada sisa yang bisa dibagi ke termin berikutnya. Termin 2 & 3 WAJIB ikut
  // dinolkan: penjaga simpan menuntut total termin tepat 100%, sehingga meninggalkan
  // sisa nilai lama di sana akan menahan dokumen dengan pesan validasi.
  //
  // Sengaja hanya bergantung pada [isJasa, isCashMode]: efek menyala sekali saat mode
  // berpindah ke Cash, lalu diam — angka yang sudah disetel tetap boleh diubah manual.
  useEffect(() => {
    if (!isJasa || !isCashMode) return;
    setTermin1("100");
    setTermin2("0");
    setTermin3("0");
  }, [isJasa, isCashMode]);

  // Auto-isi Termin 1 dari persentase Uang Muka terhadap Grand Total supplier aktif.
  // Hanya jalan untuk MSR Jasa yang PUNYA downpayment ALUR LAMA dan grand total-nya
  // sudah muncul (>0). Termin 1 tetap editable — ini sekadar saran awal; dihitung ulang
  // saat pindah tab supplier atau grand total berubah.
  //
  // Dikunci `!isCashMode` supaya dokumen Cash tak diperebutkan dua efek: pada dokumen
  // yang terlanjur punya tautan uang muka lama SEKALIGUS dipilih Cash, yang berlaku
  // adalah aturan Cash (100%).
  useEffect(() => {
    if (!isJasa || isCashMode || downpaymentAmount <= 0 || activeGrandTotal <= 0) return;
    let pct = Math.round((downpaymentAmount / activeGrandTotal) * 100);
    if (pct > 100) pct = 100;
    setTermin1(String(pct));
  }, [isJasa, isCashMode, downpaymentAmount, activeGrandTotal]);

  // Total termin untuk MSR Jasa. MSR menyimpannya 0 karena pemohon belum tahu
  // pembagiannya; di sinilah nilainya ditentukan, jadi 0 tak boleh lolos.
  const totalTermin =
    (parseFloat(Termin1) || 0) +
    (parseFloat(Termin2) || 0) +
    (parseFloat(Termin3) || 0);
  const terminValid = !isJasa || totalTermin === 100;

  const Kirim = async () => {
    if (!terminValid) {
      toast.error(
        totalTermin === 0
          ? "Termin masih 0. Isi pembagian termin hingga totalnya 100% sebelum menyimpan."
          : `Total termin harus 100%, saat ini ${totalTermin}%.`,
        { position: "bottom-right", autoClose: 5000 }
      );
      return;
    }

    let PRID;
    if (params.msr) {
      PRID = params.msr.replaceAll("-", "/");
    } else {
      PRID = values["PurchaseRequisitionIDR"];
    }

    let TransID = "";
    if (params.transid) {
      TransID = params.transid.replaceAll("-", "/");
    }

    const newValues = [];

    for (let i = 0; i < pRListComparison.length; i++) {
      let obj = ChangeToString(pRListComparison[i]);

      // Konversi PRListComparison
      if (obj["PRListComparison"]) {
        obj["PRListComparison"] = obj["PRListComparison"].map((item) => {
          const convertedItem = ChangeToString(item);
          convertedItem["PilihanBeli"] = "false";
          // Hapus field sementara
          delete convertedItem["ItemDiscount"];
          delete convertedItem["TotalAfterItemDiscount"];
          delete convertedItem["TotalBeforeDiscount"];
          return convertedItem;
        });
      }

      obj["PurchaseRequisitionID"] = PRID;
      obj["BisnisUnitID"] = params.id;
      obj["PRComparisonID"] = TransID;
      obj["Termin1"] = Termin1;
      obj["Termin2"] = Termin2;
      obj["Termin3"] = Termin3;

      try {
        const selectedPR = allPrData[values["PurchaseRequisitionID"]];
        if (selectedPR) {
          obj["DatePR"] = selectedPR["DatePR"];
        }
      } catch (error) {
        console.error("Error getting DatePR:", error);
      }

      // Handle file upload
      if (obj["NamaFile"] && typeof obj["NamaFile"] !== "string") {
        try {
          const { v4: uuidv4 } = require("uuid");
          const uuid = uuidv4();
          let formData = new FormData();
          const nama = uuid + "-" + obj["NamaFile"].name.replaceAll(" ", "_");
          formData.append("file", obj["NamaFile"], nama);

          await mutationFile.mutateAsync(formData);
          obj["NamaFile"] = nama;
        } catch (error) {
          console.error("Error uploading file:", error);
          // Fallback: save filename only
          obj["NamaFile"] = obj["NamaFile"].name;
        }
      }

      // Hapus field sementara dari objek utama
      delete obj["SubtotalBeforeDiscount"];
      delete obj["TotalItemDiscount"];
      delete obj["SubtotalAfterItemDiscount"];
      delete obj["GlobalDiscount"];
      delete obj["TotalAfterAllDiscounts"];
      delete obj["PPNPercent"];
      delete obj["PPHPercent"];
      delete obj["PBBKBPercent"];
      delete obj["PPNTotal"];
      delete obj["PPHTotal"];
      delete obj["PBBKBTotal"];
      delete obj["BiayaLainTotal"];
      delete obj["GTOTAL"];

      newValues.push(obj);
    }

    if (params.msr && params.transid) {
      PurchaseRequisitionUpdate.mutate(newValues);
    } else {
      mutationAdd.mutate(newValues);
    }
  };

  const renderSupplierContent = () => {
    if (
      !pRListComparison.length ||
      supplierSelected < 1 ||
      supplierSelected > pRListComparison.length
    ) {
      return (
        <div className="text-center py-10 text-gray-500">
          Pilih jumlah supplier terlebih dahulu
        </div>
      );
    }

    const supplierIndex = supplierSelected - 1;
    const cats = pRListComparison[supplierIndex];

    if (!cats) return null;

    const file = cats["NamaFile"] ? (
      <span>
        File Selected -{" "}
        {typeof cats["NamaFile"] === "string"
          ? cats["NamaFile"]
          : cats["NamaFile"].name}
      </span>
    ) : (
      <span>Choose a file...</span>
    );

    return (
      <div key={"Main" + supplierIndex} className={"mt-10"}>
        {showDetail && (
          <div className={"text-left items-start"}>
            <div className="grid gap-6 mb-6 md:grid-cols-3 px-3 my-4">
              <div>
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Nama Supplier/Vendor
                </label>
                {supplier.data && (
                  <Select
                    value={supplier.data.data?.filter(
                      ({ value }) => value === cats["NamaSupplier"]
                    )}
                    name={"NamaSupplier"}
                    className={
                      "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500"
                    }
                    onChange={(text) =>
                      prEditor("NamaSupplier", supplierIndex, text.value)
                    }
                    options={supplier.data.data || []}
                  />
                )}
              </div>
              <div>
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tanggal Quotation
                </label>
                <DatePicker
                  utcOffset={0}
                  dateFormat="dd/MMMM/yyyy"
                  selected={new Date(cats["TanggalKirim"])}
                  className={
                    "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  onChange={(date) =>
                    prEditor("TanggalKirim", supplierIndex, date)
                  }
                />
              </div>
              <div>
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  No. Quotation
                </label>
                <input
                  type="text"
                  value={cats["Quotation"] || ""}
                  name={"Quotation"}
                  className={
                    "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  onChange={(e) => {
                    prEditor("Quotation", supplierIndex, e.target.value);
                  }}
                />
              </div>
            </div>

            <div className="grid gap-6 mb-6 md:grid-cols-3 px-3 my-4">
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 uppercase">
                  Franco
                </label>
                {franco.data && (
                  <Select
                    value={franco.data.data?.filter(
                      ({ value }) => value === cats["FrancoID"]
                    )}
                    name={"FrancoID"}
                    className={
                      "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500"
                    }
                    onChange={(text) =>
                      prEditor("FrancoID", supplierIndex, text.value)
                    }
                    options={franco.data.data || []}
                  />
                )}
              </div>

              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 uppercase">
                  Term of Payment
                </label>
                <Select
                  value={Top.filter(({ value }) => value === cats["TOP"])}
                  name={"TOP"}
                  className={
                    "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500"
                  }
                  onChange={(text) =>
                    prEditor("TOP", supplierIndex, text.value)
                  }
                  options={Top}
                />
              </div>
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 uppercase">
                  Mata Uang
                </label>
                <Select
                  value={Currency.filter(
                    ({ value }) => value === cats["Currency"]
                  )}
                  name={"Currency"}
                  className={
                    "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500"
                  }
                  onChange={(text) =>
                    prEditor("Currency", supplierIndex, text.value)
                  }
                  options={Currency}
                />
              </div>
            </div>

            <div className="grid gap-6 mb-6 md:grid-cols-3 px-3 my-4">
              <div>
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Diskon Global menggunakan persentase (%)
                </label>
                <input
                  type="number"
                  step="any"
                  max={100}
                  min={0}
                  value={cats["DiscountPercent"] || 0}
                  name={"DiscountPercent"}
                  className={
                    "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    // Reset discount rupiah global jika menggunakan percent global
                    const newPercent = parseFloat(e.target.value) || 0;
                    if (newPercent > 0) {
                      prEditor("DiscountRupiah", supplierIndex, 0);
                    }
                    prEditor("DiscountPercent", supplierIndex, newPercent);
                  }}
                />
              </div>
              <div>
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Diskon Global menggunakan rupiah (Rp)
                </label>
                <input
                  type="number"
                  step="any"
                  min={0}
                  value={cats["DiscountRupiah"] || 0}
                  name={"DiscountRupiah"}
                  className={
                    "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    // Reset discount percent global jika menggunakan rupiah global
                    const newRupiah = parseFloat(e.target.value) || 0;
                    if (newRupiah > 0) {
                      prEditor("DiscountPercent", supplierIndex, 0);
                    }
                    prEditor("DiscountRupiah", supplierIndex, newRupiah);
                  }}
                />
              </div>
            </div>

            <div className="grid gap-6 mb-6 md:grid-cols-3 px-3 my-4">
              <div>
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  PPN (%)
                </label>
                <input
                  type="number"
                  step="any"
                  max={100}
                  min={0}
                  value={cats["PPN"] || 0}
                  name={"PPN"}
                  onWheel={(e) => e.target.blur()}
                  className={
                    "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  onChange={(e) => {
                    prEditor(
                      "PPN",
                      supplierIndex,
                      parseFloat(e.target.value) || 0
                    );
                  }}
                />
              </div>
              <div>
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  PPH (%)
                </label>
                <input
                  type="number"
                  step="any"
                  max={100}
                  min={0}
                  value={cats["PPH"] || 0}
                  name={"PPH"}
                  className={
                    "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    prEditor(
                      "PPH",
                      supplierIndex,
                      parseFloat(e.target.value) || 0
                    );
                  }}
                />
              </div>
              <div>
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  PBBKB (%)
                </label>
                <input
                  type="number"
                  step="any"
                  max={100}
                  min={0}
                  value={cats["PBBKB"] || 0}
                  onWheel={(e) => e.target.blur()}
                  name={"PBBKB"}
                  className={
                    "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  onChange={(e) => {
                    prEditor(
                      "PBBKB",
                      supplierIndex,
                      parseFloat(e.target.value) || 0
                    );
                  }}
                />
              </div>
            </div>

            {/* Biaya Lain-lain: nominal di LUAR biaya utama (tidak kena PPN/PPH/PBBKB),
                dibebankan ke Beban divisi. */}
            <div className="grid gap-6 mb-2 md:grid-cols-3 px-3">
              <div>
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Biaya Lain-lain (nominal)
                </label>
                <input
                  type="number"
                  step="any"
                  min={0}
                  value={cats["BiayaLain"] || 0}
                  onWheel={(e) => e.target.blur()}
                  name={"BiayaLain"}
                  className={
                    "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  onChange={(e) => {
                    prEditor(
                      "BiayaLain",
                      supplierIndex,
                      Math.max(0, parseFloat(e.target.value) || 0)
                    );
                  }}
                />
              </div>
              <div className="md:col-span-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Keterangan Biaya Lain-lain
                </label>
                <input
                  type="text"
                  maxLength={255}
                  value={cats["KeteranganBiayaLain"] || ""}
                  name={"KeteranganBiayaLain"}
                  placeholder="mis. Ongkos kirim, packing"
                  className={
                    "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  onChange={(e) => {
                    prEditor("KeteranganBiayaLain", supplierIndex, e.target.value);
                  }}
                />
              </div>
            </div>
            <p className="text-xs text-gray-500 px-3 mb-4">
              Biaya Lain-lain ditambahkan setelah pajak — tidak memengaruhi PPN/PPH/PBBKB — dan
              dibebankan ke akun Beban divisi.
            </p>

            <div className="grid gap-6 mb-6 px-3 my-4">
              <div>
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Term of condition
                </label>
                <textarea
                  value={cats["TOC"] || ""}
                  name={"TOC"}
                  className={
                    "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500 h-20"
                  }
                  onChange={(e) => {
                    prEditor("TOC", supplierIndex, e.target.value);
                  }}
                />
              </div>
            </div>

            <div className="grid gap-6 mb-6 px-3 my-4">
              <div>
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  {cats["NamaFile"] && "Ganti "}Data pendukung
                </label>
                <label
                  htmlFor={"NamaFile_" + supplierIndex}
                  className="block w-1/4 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500 cursor-pointer hover:bg-gray-50"
                >
                  {file}
                </label>

                <input
                  type="file"
                  id={"NamaFile_" + supplierIndex}
                  name={"NamaFile"}
                  style={{ display: "none" }}
                  className="block border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      prEditor("NamaFile", supplierIndex, file);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Ringkasan Perhitungan */}
        <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <h3 className="font-bold text-lg mb-4 text-gray-700">
            Ringkasan Perhitungan
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <p className="text-sm mb-2">
                <span className="font-medium">Subtotal Barang: </span>
                Rp{" "}
                {parseFloat(cats["SubtotalBeforeDiscount"] || 0).toLocaleString(
                  "in-ID",
                  {
                    maximumFractionDigits: 2,
                  }
                )}
              </p>
              <p className="text-sm mb-2 text-red-600">
                <span className="font-medium">Diskon per Item: </span>
                - Rp{" "}
                {parseFloat(cats["TotalItemDiscount"] || 0).toLocaleString(
                  "in-ID",
                  {
                    maximumFractionDigits: 2,
                  }
                )}
              </p>
              <p className="text-sm mb-2">
                <span className="font-medium">Subtotal setelah diskon item: </span>
                Rp{" "}
                {parseFloat(cats["SubtotalAfterItemDiscount"] || 0).toLocaleString(
                  "in-ID",
                  {
                    maximumFractionDigits: 2,
                  }
                )}
              </p>
              <p className="text-sm mb-2 text-red-600">
                <span className="font-medium">Diskon Global: </span>
                - Rp{" "}
                {parseFloat(cats["GlobalDiscount"] || 0).toLocaleString(
                  "in-ID",
                  {
                    maximumFractionDigits: 2,
                  }
                )}
              </p>
              <p className="text-sm font-bold mb-3 border-t pt-2">
                <span className="font-medium">Total setelah semua diskon: </span>
                Rp{" "}
                {parseFloat(cats["TotalAfterAllDiscounts"] || 0).toLocaleString(
                  "in-ID",
                  {
                    maximumFractionDigits: 2,
                  }
                )}
              </p>
            </div>
            <div>
              <p className="text-sm mb-2">
                <span className="font-medium">PPN ({cats["PPN"] || 0}%): </span>
                + Rp{" "}
                {parseFloat(cats["PPNTotal"] || 0).toLocaleString("in-ID", {
                  maximumFractionDigits: 2,
                })}
              </p>
              <p className="text-sm mb-2 text-red-600">
                <span className="font-medium">PPH ({cats["PPH"] || 0}%): </span>
                - Rp{" "}
                {parseFloat(cats["PPHTotal"] || 0).toLocaleString("in-ID", {
                  maximumFractionDigits: 2,
                })}
              </p>
              <p className="text-sm mb-2">
                <span className="font-medium">PBBKB ({cats["PBBKB"] || 0}%): </span>
                + Rp{" "}
                {parseFloat(cats["PBBKBTotal"] || 0).toLocaleString("in-ID", {
                  maximumFractionDigits: 2,
                })}
              </p>
              {parseFloat(cats["BiayaLain"] || 0) > 0 && (
                <p className="text-sm mb-2">
                  <span className="font-medium">
                    Biaya Lain-lain{cats["KeteranganBiayaLain"] ? ` (${cats["KeteranganBiayaLain"]})` : ""}:{" "}
                  </span>
                  + Rp{" "}
                  {parseFloat(cats["BiayaLain"] || 0).toLocaleString("in-ID", {
                    maximumFractionDigits: 2,
                  })}
                </p>
              )}
              <p className="text-lg font-bold mb-3 border-t pt-2 text-green-700">
                <span className="font-medium">Grand Total: </span>
                Rp{" "}
                {parseFloat(cats["GTOTAL"] || 0).toLocaleString("in-ID", {
                  maximumFractionDigits: 2,
                })}
              </p>
            </div>
          </div>
        </div>

        {/* Tabel Detail Barang */}
        <table className="table-auto w-full text-sm text-left text-gray-500 mt-10">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              <th scope="col" className="py-3 px-6" rowSpan={2}>
                Barang/Jasa
              </th>
              <th scope="col" className="py-3 px-6" rowSpan={2}>
                JUMLAH PENGAJUAN
              </th>
              <th scope="col" className="py-3 px-6" rowSpan={2}>
                Harga Satuan
              </th>
              <th
                scope="col"
                className="py-3 px-6 text-center border-b"
                colSpan={2}
              >
                Diskon Per Item
              </th>
              <th scope="col" className="py-3 px-6" rowSpan={2}>
                Merek/Tipe Barang
              </th>
              <th scope="col" className="py-3 px-6" rowSpan={2}>
                Total Harga (Qty × Harga)
              </th>
            </tr>
            <tr>
              <th scope="col" className="py-3 px-6 text-center">
                %
              </th>
              <th scope="col" className="py-3 px-6 text-center">
                Rp
              </th>
            </tr>
          </thead>

          <tbody>
            {cats["PRListComparison"] &&
              cats["PRListComparison"].map((detail, id) => {
                const classOdd =
                  id % 2 === 0
                    ? "bg-white border-b hover:bg-gray-50"
                    : "bg-gray-50 border-b hover:bg-gray-100";

                // NamaBarang sudah disertakan langsung dari backend
                const texts = detail.NamaBarang
                  ? `${detail.BarangID} - ${detail.NamaBarang}`
                  : detail.BarangID || "";

                return (
                  <tr key={id} className={classOdd}>
                    <th
                      scope="row"
                      className="py-4 px-6 font-medium whitespace-nowrap"
                    >
                      {texts}
                    </th>
                    <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                      {parseFloat(detail["Qty"] || 0).toLocaleString("in-ID", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="py-4 px-6">
                      <input
                        type="number"
                        step="any"
                        value={detail["Harga"] || 0}
                        name={"Harga"}
                        className="appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-2 px-3 leading-tight outline-none bg-white"
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {
                          PurchaseRequisitionDetailEditor(supplierIndex, id, e);
                        }}
                      />
                    </td>
                    <td className="py-4 px-6">
                      <input
                        type="number"
                        step="any"
                        value={detail["DiscountPercent"] || 0}
                        max={100}
                        name={"DiscountPercent"}
                        onWheel={(e) => e.target.blur()}
                        className="appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-2 px-3 leading-tight outline-none bg-white"
                        onChange={(e) => {
                          const tempArray = [...pRListComparison];
                          const selectedSupplier = tempArray[supplierIndex];

                          if (
                            !selectedSupplier ||
                            !selectedSupplier.PRListComparison
                          )
                            return;

                          const fieldValue = parseFloat(e.target.value) || 0;
                          selectedSupplier.PRListComparison[id][
                            "DiscountPercent"
                          ] = fieldValue;

                          // Jika ada diskon persen per item, reset diskon rupiah per item
                          if (fieldValue > 0) {
                            selectedSupplier.PRListComparison[id][
                              "DiscountRupiah"
                            ] = 0;
                          }

                          // Hitung ulang
                          tempArray[supplierIndex] =
                            calculateSupplierTotal(selectedSupplier);
                          setPRListComparison(tempArray);
                        }}
                      />
                    </td>
                    <td className="py-4 px-6">
                      <input
                        type="number"
                        step="any"
                        onWheel={(e) => e.target.blur()}
                        value={detail["DiscountRupiah"] || 0}
                        name={"DiscountRupiah"}
                        className="appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-2 px-3 leading-tight outline-none bg-white"
                        onChange={(e) => {
                          const tempArray = [...pRListComparison];
                          const selectedSupplier = tempArray[supplierIndex];

                          if (
                            !selectedSupplier ||
                            !selectedSupplier.PRListComparison
                          )
                            return;

                          const fieldValue = parseFloat(e.target.value) || 0;
                          selectedSupplier.PRListComparison[id][
                            "DiscountRupiah"
                          ] = fieldValue;

                          // Jika ada diskon rupiah per item, reset diskon persen per item
                          if (fieldValue > 0) {
                            selectedSupplier.PRListComparison[id][
                              "DiscountPercent"
                            ] = 0;
                          }

                          // Hitung ulang
                          tempArray[supplierIndex] =
                            calculateSupplierTotal(selectedSupplier);
                          setPRListComparison(tempArray);
                        }}
                      />
                    </td>
                    <td className="py-4 px-6">
                      <input
                        type="text"
                        value={detail["Merk"] || ""}
                        name={"Merk"}
                        className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-2 px-3 leading-tight outline-none bg-white"
                        onChange={(e) => {
                          PurchaseRequisitionDetailEditor(supplierIndex, id, e);
                        }}
                      />
                    </td>
                    <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                      {parseFloat(detail["TotalHarga"] || 0).toLocaleString(
                        "in-ID",
                        {
                          maximumFractionDigits: 2,
                        }
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>

          <tfoot>
            <tr className="bg-gray-50">
              <th
                scope="row"
                colSpan={6}
                className="py-4 px-6 font-medium whitespace-nowrap text-right"
              >
                Subtotal Barang
              </th>
              <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                Rp{" "}
                {parseFloat(cats["SubtotalBeforeDiscount"] || 0).toLocaleString(
                  "in-ID",
                  {
                    maximumFractionDigits: 2,
                  }
                )}
              </td>
            </tr>

            <tr className="bg-white text-red-600">
              <th
                scope="row"
                colSpan={6}
                className="py-4 px-6 font-medium whitespace-nowrap text-right"
              >
                Diskon per Item
              </th>
              <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                - Rp{" "}
                {parseFloat(cats["TotalItemDiscount"] || 0).toLocaleString(
                  "in-ID",
                  {
                    maximumFractionDigits: 2,
                  }
                )}
              </td>
            </tr>

            <tr className="bg-gray-50">
              <th
                scope="row"
                colSpan={6}
                className="py-4 px-6 font-medium whitespace-nowrap text-right"
              >
                Subtotal setelah diskon per item
              </th>
              <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                Rp{" "}
                {parseFloat(cats["SubtotalAfterItemDiscount"] || 0).toLocaleString(
                  "in-ID",
                  {
                    maximumFractionDigits: 2,
                  }
                )}
              </td>
            </tr>

            <tr className="bg-white text-red-600">
              <th
                scope="row"
                colSpan={6}
                className="py-4 px-6 font-medium whitespace-nowrap text-right"
              >
                Diskon Global
              </th>
              <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                - Rp{" "}
                {parseFloat(cats["GlobalDiscount"] || 0).toLocaleString(
                  "in-ID",
                  {
                    maximumFractionDigits: 2,
                  }
                )}
              </td>
            </tr>

            <tr className="bg-gray-100 font-bold border-t border-gray-300">
              <th
                scope="row"
                colSpan={6}
                className="py-4 px-6 font-medium whitespace-nowrap text-right"
              >
                Total Setelah Semua Diskon
              </th>
              <td className="py-4 px-6 font-medium whitespace-nowrap text-right border-t-2 border-gray-500">
                Rp{" "}
                {parseFloat(cats["TotalAfterAllDiscounts"] || 0).toLocaleString(
                  "in-ID",
                  {
                    maximumFractionDigits: 2,
                  }
                )}
              </td>
            </tr>

            <tr className="bg-white">
              <th
                scope="row"
                colSpan={6}
                className="py-4 px-6 font-medium whitespace-nowrap text-right"
              >
                PPN ({cats["PPN"] || 0}%)
              </th>
              <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                + Rp{" "}
                {parseFloat(cats["PPNTotal"] || 0).toLocaleString("in-ID", {
                  maximumFractionDigits: 2,
                })}
              </td>
            </tr>

            <tr className="bg-gray-50 text-red-600">
              <th
                scope="row"
                colSpan={6}
                className="py-4 px-6 font-medium whitespace-nowrap text-right"
              >
                PPH ({cats["PPH"] || 0}%)
              </th>
              <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                - Rp{" "}
                {parseFloat(cats["PPHTotal"] || 0).toLocaleString("in-ID", {
                  maximumFractionDigits: 2,
                })}
              </td>
            </tr>

            <tr className="bg-white">
              <th
                scope="row"
                colSpan={6}
                className="py-4 px-6 font-medium whitespace-nowrap text-right"
              >
                PBBKB ({cats["PBBKB"] || 0}%)
              </th>
              <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                + Rp{" "}
                {parseFloat(cats["PBBKBTotal"] || 0).toLocaleString("in-ID", {
                  maximumFractionDigits: 2,
                })}
              </td>
            </tr>

            {parseFloat(cats["BiayaLain"] || 0) > 0 && (
              <tr className="bg-gray-50">
                <th
                  scope="row"
                  colSpan={6}
                  className="py-4 px-6 font-medium whitespace-nowrap text-right"
                >
                  Biaya Lain-lain{cats["KeteranganBiayaLain"] ? ` (${cats["KeteranganBiayaLain"]})` : ""}
                </th>
                <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                  + Rp{" "}
                  {parseFloat(cats["BiayaLain"] || 0).toLocaleString("in-ID", {
                    maximumFractionDigits: 2,
                  })}
                </td>
              </tr>
            )}
            <tr className="bg-green-50 font-bold border-t-2 border-gray-500">
              <th
                scope="row"
                colSpan={6}
                className="py-4 px-6 font-medium whitespace-nowrap text-right text-green-700"
              >
                GRAND TOTAL
              </th>
              <td className="py-4 px-6 font-medium whitespace-nowrap text-right text-green-700">
                Rp{" "}
                {parseFloat(cats["GTOTAL"] || 0).toLocaleString("in-ID", {
                  maximumFractionDigits: 2,
                })}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  };

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row">
                  <button
                    onClick={() =>
                      navigate(
                        "/procurment/transaksi/price-comparison/" + params.id
                      )
                    }
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded transition-colors"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                  <button
                    onClick={Kirim}
                    disabled={
                      mutationAdd.isLoading ||
                      PurchaseRequisitionUpdate.isLoading ||
                      !terminValid
                    }
                    title={
                      !terminValid
                        ? "Total termin harus 100% sebelum bisa disimpan"
                        : ""
                    }
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-main-100 hover:bg-main-200 text-white font-semibold py-2 px-4 border border-main-100 shadow rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {mutationAdd.isLoading ||
                    PurchaseRequisitionUpdate.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor"
                          />
                        </svg>
                        Loading
                      </>
                    ) : (
                      "Simpan"
                    )}
                  </button>
                </div>

                <div className={"row-auto mt-6"}>
                  {PurchaseRequisition.isLoading ? (
                    <div className="w-full md:w-1/3 px-3 mb-5">
                      <div className="bg-gray-100 animate-pulse h-10 rounded"></div>
                    </div>
                  ) : PurchaseRequisition.data ? (
                    <>
                      <div className={"w-full md:w-1/3 px-3 mb-5"}>
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                          Nomor MSR
                        </label>
                        <Select
                          value={selectedPROption}
                          name={"PurchaseRequisitionID"}
                          className={
                            (touched["PurchaseRequisitionID"] ||
                              buttonTouched) &&
                            errors["PurchaseRequisitionID"]
                              ? "appearance-none block w-full text-gray-700 border border-red-500 outline-none bg-white"
                              : "appearance-none block w-full text-gray-700 border border-gray-200 outline-none bg-white"
                          }
                          onChange={(text) =>
                            PRHandlerWithMSR(
                              text.label,
                              text.value,
                              "PurchaseRequisitionID",
                              text.PurchaseRequisitionID
                            )
                          }
                          onInputChange={handleMsrInputChange}
                          onMenuOpen={() => {
                            if (!msrSearchInput.trim()) {
                              setPRData(
                                filterMsrOptions(allPrData, msrSearchInput)
                              );
                            }
                          }}
                          filterOption={() => true}
                          maxMenuHeight={320}
                          noOptionsMessage={() =>
                            msrSearchInput
                              ? "Tidak ada MSR yang cocok"
                              : "Data MSR tidak tersedia"
                          }
                          options={prData}
                        />
                      </div>

                      {selectedPROption && (
                        <>
                          <div className={"w-full md:w-1/3 px-3 mb-5"}>
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                              Tanggal MSR
                            </label>
                            <div className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white">
                              {new Date(
                                selectedPROption["DatePR"]
                              )
                                .toISOString()
                                .substring(0, 10)}
                            </div>
                          </div>

                          {/* Term of Payment / Cash.
                              INILAH penentu jalur uang muka. Memilih "Cash" berarti dokumen
                              downpayment TIDAK lagi dibuat manual di Form Kas Bank: backend
                              menciptakannya otomatis saat approval PC final, sebesar Grand Total
                              (lihat createDownpaymentFromCashPC di PriceComparison.go), lalu
                              dokumen itu masuk antrean Pembayaran Non-PO seperti biasa.
                              Memilih "Term of Payment" = tanpa uang muka; jangka waktunya
                              (90/60/30/20/15/7 hari) diisi per supplier di tab masing-masing.
                              Select ini menulis ke kolom yang SAMA (PRComparison."top"), jadi ia
                              dan dropdown Term of Payment per supplier tak bisa berbeda pendapat. */}
                          <div className={"w-full md:w-1/3 px-3 mb-5"}>
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                              Term of Payment / Cash
                            </label>
                            <Select
                              value={
                                adaTopTerisi
                                  ? ModePembayaran.filter(
                                      ({ value }) =>
                                        value === (isCashMode ? "cash" : "top")
                                    )
                                  : []
                              }
                              placeholder={"Pilih…"}
                              options={ModePembayaran}
                              onChange={(pilihan) =>
                                setModePembayaran(pilihan.value)
                              }
                              className={
                                "appearance-none block w-full text-gray-700 border border-gray-200 outline-none bg-white border-gray-500"
                              }
                            />
                            {isCashMode ? (
                              <div className="mt-2 border border-amber-200 bg-amber-50 rounded py-2 px-3">
                                <span className="font-bold text-amber-800">
                                  Uang muka Rp{" "}
                                  {(cashDownpaymentAmount ||
                                    cashDownpaymentEstimasi).toLocaleString(
                                    "in-ID",
                                    { maximumFractionDigits: 2 }
                                  )}
                                </span>
                                <span className="block text-xs text-amber-700 mt-1">
                                  Dibentuk otomatis saat approval final, sebesar Grand
                                  Total. Bila beberapa supplier Cash terpilih, nominalnya
                                  = Grand Total terendah di antaranya. Tak perlu lagi
                                  dibuat manual di Form Kas Bank.
                                  {isJasa
                                    ? " Termin 1 otomatis diisi 100% (Termin 2 & 3 = 0)."
                                    : ""}
                                </span>
                              </div>
                            ) : adaTopTerisi ? (
                              <span className="block text-xs text-gray-500 mt-2">
                                Tanpa uang muka. Jangka waktu pembayaran diisi di dropdown
                                Term of Payment tiap supplier.
                              </span>
                            ) : (
                              <span className="block text-xs text-gray-500 mt-2">
                                Belum dipilih. "Cash" membentuk uang muka otomatis sebesar
                                Grand Total; "Term of Payment" mengisi jangka waktu per
                                supplier.
                              </span>
                            )}
                            {/* Data LAMA yang terlanjur menautkan
                                PurchaseRequisition."DownpaymentCashJournalID" lewat alur
                                manual — ditampilkan agar tak terlihat hilang. */}
                            {!isCashMode && downpaymentAmount > 0 && (
                              <div className="mt-2 border border-blue-200 bg-blue-50 rounded py-2 px-3">
                                <span className="font-bold text-blue-800">
                                  Uang muka lama Rp{" "}
                                  {parseFloat(downpaymentAmount).toLocaleString(
                                    "in-ID",
                                    { maximumFractionDigits: 2 }
                                  )}
                                </span>
                                <span className="block text-xs text-blue-700 mt-1">
                                  Berasal dari referensi manual di MSR (alur lama).
                                </span>
                              </div>
                            )}
                          </div>

                          <div className={"w-full px-3 mb-5"}>
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                              Keterangan
                            </label>
                            <div className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white">
                              {
                                selectedPROption["Remarks"]
                              }
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <div className="w-full md:w-1/3 px-3 mb-5">
                      <div className="text-center py-3 text-gray-600">
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-5 h-5 text-gray-600 animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor"
                          />
                        </svg>
                        Loading data MSR...
                      </div>
                    </div>
                  )}
                </div>

                <div className="w-full md:w-1/4 px-3 mb-5">
                  <HrdInputGenerator
                    type={"number"}
                    value={values}
                    name={"SupplierCount"}
                    title={"Jumlah Supplier"}
                    onChange={SupplierCount}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                    min={0}
                  />
                </div>

                <hr className="my-6" />

                {PurchaseRequisitionDetail.isLoading || barangDetail.isLoading ? (
                  <Skeltons />
                ) : (
                  <DynamicTableSimple
                    data={barang}
                    header={header}
                    OnClick={ModalOpener}
                    name={"Purchase Requisition"}
                    barang={barangDetail.data}
                  />
                )}

                <hr className={"my-8"} />

                {/* Tab Navigation */}
                <div className="mb-6">
                  <div className="border-b border-gray-200">
                    <div className="flex flex-wrap items-center justify-between">
                      <ul
                        className="flex flex-wrap -mb-px text-sm font-medium text-center"
                        role="tablist"
                      >
                        {SupplierBuilder()}
                      </ul>
                      <button
                        onClick={() => setshowDetail(!showDetail)}
                        className={`inline-block p-3 rounded-lg text-sm font-medium transition-colors ${
                          showDetail
                            ? "bg-main-100 text-white hover:bg-main-200"
                            : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                        }`}
                        type="button"
                      >
                        {showDetail ? "Sembunyikan" : "Tampilkan"} Supplier Data
                      </button>
                    </div>
                  </div>

                  {/* Tab Content */}
                  <div className="mt-6">{renderSupplierContent()}</div>
                </div>

                {/* Termin pembayaran (MSR Jasa) — diletakkan di bawah, setelah
                    Grand Total, agar Termin 1 dapat dihitung dari persentase Uang
                    Muka terhadap Grand Total supplier yang sedang aktif. */}
                {isJasa && (
                  <>
                    <hr className="my-6" />
                    <h3 className="px-3 mb-3 text-sm font-bold uppercase tracking-wide text-gray-700">
                      Termin Pembayaran
                    </h3>
                    {downpaymentAmount > 0 && (
                      <p className="px-3 mb-3 text-xs text-blue-700 bg-blue-50 border border-blue-200 rounded py-2">
                        Uang Muka{" "}
                        <b>
                          Rp{" "}
                          {parseFloat(downpaymentAmount).toLocaleString("in-ID", {
                            maximumFractionDigits: 2,
                          })}
                        </b>{" "}
                        terdeteksi. Termin 1 diisi otomatis ={" "}
                        {activeGrandTotal > 0 ? (
                          <b>
                            {Math.min(
                              100,
                              Math.round(
                                (downpaymentAmount / activeGrandTotal) * 100
                              )
                            )}
                            %
                          </b>
                        ) : (
                          <b>—</b>
                        )}{" "}
                        (Uang Muka ÷ Grand Total supplier aktif). Nilai masih bisa
                        Anda ubah manual.
                      </p>
                    )}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 px-3 mb-5">
                      <div>
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                          Termin 1 (%)
                        </label>
                        <input
                          className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight outline-none bg-white"
                          name="Termin1"
                          type="number"
                          min="0"
                          max="100"
                          onChange={onChangeTermin}
                          value={Termin1}
                        />
                      </div>
                      <div>
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                          Termin 2 (%)
                        </label>
                        <input
                          className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight outline-none bg-white"
                          name="Termin2"
                          type="number"
                          min="0"
                          max="100"
                          onChange={onChangeTermin}
                          value={Termin2}
                        />
                      </div>
                      <div>
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                          Termin 3 (%)
                        </label>
                        <input
                          className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight outline-none bg-white"
                          name="Termin3"
                          type="number"
                          min="0"
                          max="100"
                          onChange={onChangeTermin}
                          value={Termin3}
                        />
                      </div>
                      <div className="md:col-span-3">
                        {terminValid ? (
                          <p className="text-sm font-semibold text-green-700">
                            Total termin {totalTermin}% ✓
                          </p>
                        ) : (
                          <p className="text-sm font-semibold text-red-600">
                            ⚠ Total termin {totalTermin}% — harus tepat 100%
                            sebelum bisa disimpan.
                            {totalTermin === 0 &&
                              " Termin belum diisi (MSR menyimpannya 0)."}
                          </p>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsertPriceComparisonPage;
